import Tagpay from "./component"

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react"
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
const TagListContainer=(props)=>{
  const navigate=useNavigate()
  const { makeApiRequest } = useApiRequest()
    const [tagList,setTagList]=useState([])
    const [loader,setLoader]=useState(false)
 
    useEffect(()=>{
        getTagList()
    },[])

    useEffect(() => {
      const UserJWTAuth = localStorage.getItem("UserJWTAuth");
      //console.log("UserJWTAuth VmlistContainer", UserJWTAuth);
      if (!UserJWTAuth) {
        navigate("/login");
      }
    }, []);
  

const handleResponseTagList=(res)=>{

  setTagList(res.data.response);
  setLoader(false)

}

const handleErrorTagList=(error)=>{
  setLoader(false)
  if(error.response.status==401 || error.response.status==403){

    //console.log("khanhandleErrorTagList", error.response);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
      //navigate("/login");
}
else{ toast.error(`${error.response.data.status.code}`, {
  position: "top-right",
  autoClose: 1000,
});
}

}


const getTagList = () => {
  
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  //console.log("UserJWTAuth",UserJWTAuth)
  setLoader(true)
  //console.log("inventory...container")



    makeApiRequest({
    url: `https://api-prod.daalchini.co.in/auth/tag/linked`,
     method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },
    data:{      },
     handleSuccess: (res) => handleResponseTagList(res),
         handleError: (res) => handleErrorTagList
  });


};



    return(
        <Tagpay
        tagList={tagList}
        loader={loader}
        />


    )
}

  export default TagListContainer;

